import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getIngresosEmpleado.php';

export default function getIngresosEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}